export default (number = 0) => {
  return number
  // if (number === 0) {
  //   return 0
  // }
  // const parts = number ? number.toString().split('.') : ['']
  // parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
  // return parts.join('.')
}
